import { addCollection, type IconifyJSON } from '@iconify/react';
import { iconsMetadata } from '@/lib/generated/icons-spec.gen';

for (const collection of iconsMetadata) {
	addCollection(collection as IconifyJSON);
}
